export const viewOptionSliceName = "viewOptions";
//# sourceMappingURL=constants.js.map